var _rect, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#009EE3",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15453_54108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15146 6.29529H13.105C15.2277 6.29529 16.0268 7.36861 15.9033 8.94548C15.7002 11.5508 14.1245 12.9891 12.0334 12.9891H10.9782C10.6914 12.9891 10.4986 13.1776 10.421 13.6924L9.96788 16.6789C9.93829 16.8726 9.83623 16.9847 9.68315 17H7.20429C6.97059 17 6.88793 16.8216 6.94916 16.4363L8.4626 6.861C8.52384 6.47774 8.73304 6.29529 9.15146 6.29529Z",
    fill: "#009EE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6772 2.99988H10.6328C11.7553 2.99988 13.0728 3.03555 13.9566 3.81532C14.5475 4.33516 14.8578 5.16488 14.7863 6.05779C14.5434 9.07696 12.7361 10.767 10.3113 10.767H8.35903C8.02736 10.767 7.80693 10.9871 7.71304 11.5824L7.16808 15.048C7.13338 15.2723 7.03541 15.4048 6.86192 15.4201H4.41979C4.14935 15.4201 4.05343 15.2162 4.12384 14.7657L5.87915 3.65631C5.94957 3.21189 6.19347 2.99988 6.6772 2.99988Z",
    fill: "#113984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77344 11.2308L8.46433 6.861C8.52557 6.47774 8.73477 6.29529 9.15319 6.29529H13.1016C13.7558 6.29529 14.2854 6.39722 14.6998 6.58477C14.3018 9.27165 12.5628 10.7639 10.2839 10.7639H8.33269C8.0796 10.7639 7.88365 10.8954 7.77344 11.2308Z",
    fill: "#172C70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15453_54108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8126,
    height: 14.0001,
    fill: "white",
    transform: "translate(4.10156 2.99976)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.b026c6200cf000581ea86ed810b97f65.svg";
export { ForwardRef as ReactComponent };